<template>
  <div class="meet_more_users_container">
    <div class="h1">{{ trans('meet_now') }}</div>
    <div class="faces" >
      <div class="face meet_now" v-for="meetNowUser in meetNowUsers"
           :dusk="'meet-now-'+meetNowUser.id" href="javascript:void(0)"
           v-on:click="openUser(meetNowUser)"
           :class="{'default-photo': meetNowUser.photo_small === '/assets/img/default_180x180.jpg', 'sensitive': meetNowUser.photo_small === '/assets/img/toohot_180x180.jpg'}">
        <div class="img" :style="{'background': `url(${meetNowUser.photo_small}) no-repeat center / cover`}"></div>
        <div class="details">
          <div class="name notranslate">{{ meetNowUser.headline }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';

export default {
  mixins: [
    require('@general/lib/mixin').default,
  ],
  props: [],
  data() {
    return {
    }
  },
  components: {
  },
  computed: {
    ...mapState({

    }),
    ...mapGetters({
      meetNowUsers: 'meetNowUsers'
    })
  },
  methods: {
    openUser(user){
      if(this.isMobile){
          this.goToProfile(user);
      }else{
          this.openUserModal(user.id)
      }
    },
    goToProfile(user) {
      this.goTo('/user/' + user.id)
      // this.$router.push({ hash: '#userModal='+user.id })
      //this.openUserMobileModal(user.id, 2)
    },
  },
  mounted() {
  },
  deactivated() {
  },
  destroyed() {
  }
}
</script>